import type { AgentStateKey } from '../types/voip';

/** Five9 floor-time segments in stacked-bar order. Ready and Waiting together make up all Ready time. */
export const agentStates: { key: AgentStateKey; label: string; hint: string; className: string }[] = [
  { key: 'onCall', label: 'On Call', hint: 'Talk time', className: 'bg-accent' },
  { key: 'readyActive', label: 'Ready', hint: 'Ringing or reserved', className: 'bg-bright' },
  { key: 'waiting', label: 'Waiting', hint: 'Ready but idle', className: 'bg-bright/30' },
  { key: 'notReady', label: 'Not Ready', hint: 'Incl. after-call work', className: 'bg-silver/45' },
];
